import { commonEnv } from './environment.common';

export const environment = {
  ...commonEnv,
  environmentLabel: null,
  activatedTenants: [3550, 3645, 3752, 3751, 3551, 3351],
  production: true,
  version: '1.13.638',
  commitHash: '5a1e293c4bd32cb22c7082d6120c8afb31102ce2',
  sentry: 'https://622dea0819e449c891cd503b72e2e393@o296516.ingest.sentry.io/5193397',
  zulipUrl: 'https://zulip.glb.ch',
  zulipBucketUrl:
    'https://digizeit-api.mlink.glb.ch/api/zulip/uploads?token=$UPLOAD_TOKEN&path=',
  // kronosApiUrl: 'https://digizeit-api.mlink.glb.ch',
  kronosApiUrl: 'http://localhost:5000',
  auth: {
    serverUrl: 'https://auth.cloud.triarc-labs.com/auth/',
    clientId: 'kronos',
    bearerExcludedUrls: ['http://localhost:4200'],
    scope: 'openid email profile offline_access',
    twoFaTimeLimit: 120,
    logoutUrl: 'http://localhost:4200',
  },
  salesOrder: {
    viewDiscountPreAbacus: [],
    viewDiscountPostAbacus: [],
    canEditDiscountPreAbacus: [],
    viewDiscountSpecialPreAbacus: [],
    viewDiscountSpecialPostAbacus: [],
    canEditDiscountSpecialPreAbacus: [],
  },
  showTimeDifferenceOverview: true,
  features: {
    3550: ['time', 'sales', 'purchase', 'chat'],
    3645: ['time', 'sales', 'purchase', 'chat'],
    3752: ['time', 'sales', 'purchase', 'chat'],
    3751: ['time', 'sales', 'purchase', 'chat'],
    3551: ['time', 'sales', 'purchase', 'chat'],
    3351: ['time', 'sales', 'purchase', 'chat'],
  },
  oneSignal: {
    localhost: {
      appId: 'bdb0000d-ee99-4807-b2aa-c0b0f066b194',
    },
    'digizeit.mlink.glb.ch': {
      appId: 'bdb0000d-ee99-4807-b2aa-c0b0f066b194',
    },
    'my.glb.ch': {
      appId: '9b0fe937-238f-4819-a416-e37520920294',
    },
    'my.bernaroof.ch': {
      appId: '0fad08d1-842e-44e3-8744-414c0efe9a6c',
    },
    'my.bauimpuls.ch': {
      appId: 'ff5c4039-711a-4fe5-a509-6651626f9838',
    },
    'my.allotherm.ch': {
      appId: '9059fbae-6135-4aaf-92d3-031949457de3',
    },
    'my.asag-asbest.ch': {
      appId: 'fe0559d4-28b3-4983-aa7e-4af9cfa7fad1',
    },
    'my2.asag-asbest.ch': {
      appId: '__TODO_ONESIGNAL_ASAG2_PROD_APP_ID__',
    },
  },
  myAbacus: 'https://myabacus.glb-gruppe.ch:40001/portal/myabacus/welcome',
  customerHub: 'https://kunde.glbgruppe.ch',
  uka: 'https://glb-genossenschaft.uka.ch/send/?authKey=742facc7-8ab1-4b9e-9885-b9a0b2e2f413&subtenant=Standard',
};
